/* eslint-disable react/jsx-props-no-spreading */
import { FC } from 'react';
import { Tooltip } from 'react-tooltip';
import { useTranslate } from 'hooks/useTranslate';

import IconTooltip from 'modules/_shared/components/Icon/IconTooltip';

import { useBeneficiarySellModal } from '../context/BeneficiarySellModalContext';

const SimulationView: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useBeneficiarySellModal();

  return (
    <div className="invoice-contact col-12 col-md-6 d-print-inline-block">
      <span className="overline-title">{t('Conditions')}</span>

      <div className="invoice-contact-info">
        <h5 className="title mb-3">{t('Customizables')}</h5>
      </div>

      <div className="row">
        <div className="form-group col-12 col-md-7">
          <label className="form-label" htmlFor="simulated-society-value">
            {data.includeAllUnits
              ? t('SocietyValuationFD')
              : t('SocietyValuationAD')}
            {data.includeAllUnits && (
              <em
                className="icon ni ni-info notification-icon ml-1 text-primary"
                id="icon-society-value-tooltip"
              />
            )}
          </label>

          {data.includeAllUnits && (
            <Tooltip
              anchorSelect="#icon-society-value-tooltip"
              content={t('SocietyValueSwitchMessage')}
            />
          )}

          <div className="form-control-wrap">
            <div className="form-control-wrap">
              <div className="form-text-hint">
                <span>€</span>
              </div>
              <input
                type="number"
                className="form-control form-control-lg"
                value={data.simulatedSocietyValue}
                onChange={actions.handleChangeSimulatedSocietyValue}
                min={0}
                step="0.01"
              />
            </div>
          </div>
        </div>

        <div className="form-group col-12 col-md-5">
          <label className="form-label" htmlFor="simulated-society-retention">
            {t('Retention')}
            <em
              className="icon ni ni-info notification-icon ml-1 text-primary"
              id="icon-society-retention-tooltip"
            />
          </label>

          <Tooltip
            anchorSelect="#icon-society-retention-tooltip"
            content={t('RetentionTooltip')}
            place="top"
            style={{ maxWidth: '300px', zIndex: 999 }}
          />

          <div className="form-control-wrap">
            <div className="form-control-wrap">
              <div className="form-text-hint">
                <span>%</span>
              </div>
              <input
                type="number"
                className="form-control form-control-lg"
                value={data.simulatedRetentionPercent}
                onChange={actions.handleChangeSimulatedRetentionPercent}
                min={0}
                step="0.01"
              />
            </div>
          </div>
        </div>

        <div className="col-12">
          <div className="custom-control custom-checkbox custom-control-sm">
            <input
              type="checkbox"
              className="custom-control-input"
              id="include-all-units"
              checked={!data.includeAllUnits}
              onChange={actions.handleChangeIncludeAllUnits}
            />
            <label className="custom-control-label" htmlFor="include-all-units">
              {t('SocietyValuationAD')}
            </label>
            <IconTooltip
              id="society-valuation-ad-tooltip"
              tooltip={t('SocietyValuationADTooltip')}
              className="icon ni ni-info notification-icon text-primary mb-1"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimulationView;
